import { RequestSender } from "./helpers";

type AuthAndPopulateClassWalletSessionInput = {
  readonly orderId: string;
  readonly password: string;
  readonly userAuthType: "sign-up" | "sign-in";
};

async function authAndPopulateClassWalletSessionItemsNoStu(
  request: RequestSender,
  { orderId, userAuthType, password }: AuthAndPopulateClassWalletSessionInput,
): Promise<void> {
  const response = await request<any>(
    "put",
    `/class-wallet/order-sessions/${encodeURIComponent(orderId)}/items`,
    {
      userAuthType,
      password,
    },
  );
  if (response.status !== 204) {
    throw new Error(response.data.message);
  }
}

export type { AuthAndPopulateClassWalletSessionInput };
export default authAndPopulateClassWalletSessionItemsNoStu;
